import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TokenStorageService } from '../data-access/token-storage.service';

const OAUTH_ENDPOINTS = [
  '/oauth2/token',
  '/oauth2/authorize',
  '/oauth2/revoke',
  '/oauth2/logout',
  '/.well-known/openid-configuration',
  '/jwks.json',
];

let redirectingToLogin = false;

function isOAuthRequest(url: string): boolean {
  return OAUTH_ENDPOINTS.some((endpoint) => url.includes(endpoint));
}

export const httpErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const router = inject(Router);
  const tokenStorage = inject(TokenStorageService);

  if (isOAuthRequest(req.url)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        tokenStorage.clearToken();
        localStorage.removeItem('user_permissions');

        /*const currentUrl = router.url;

        if (currentUrl.startsWith('/login/proveedores')) {
          router.navigate(['/login/proveedores'], {
            // queryParams: { sessionExpired: 'true' },
          });
        } else {
          // Redirigir al login
          router.navigate(['/login'], {
            // queryParams: { sessionExpired: 'true' },
          });
        }*/
        if (!redirectingToLogin && !router.url.startsWith('/login')) {
          redirectingToLogin = true;
          router
            .navigate(['/login'], {
              queryParams: { sessionExpired: 'true' },
            })
            .finally(() => {
              redirectingToLogin = false;
            });
        }
      }

      return throwError(() => error);
    }),
  );
};
